<template>
  <div class="price-checker-container">
    <div class="price-cheker-heading">
      日本卸電力取引所JEPXでの電力取引価格が一目でわかるサービス。毎日12時頃に翌日分の値が自動更新されます。
    </div>
    <!-- 翌日のスポット価格 -->
    <JepxOverviewChart class="overview-chart" />
    <!-- 時系列分析：スポット価格 -->
    <JepxDetailChart ref="detailChart" class="detail-chart" />
  </div>
</template>

<script>
import JepxOverviewChart from '../../components/JepxOverviewChart'
import JepxDetailChart from '../../components/JepxDetailChart'

export default {
  name: 'PriceChecker',
  components: {
    JepxOverviewChart,
    JepxDetailChart,
  },
  async mounted() {
    await new Promise((resolve) => setTimeout(resolve, 200))
    const hasTimeseriesHash = window.location.hash === '#timeseries'
    if (hasTimeseriesHash) {
      const el = this.$refs.detailChart
      const targetPosition = el.$el.offsetTop
      window.scroll({ top: targetPosition })
    }
  },
}
</script>

<style lang="scss" scoped>
.price-checker-container {
  max-width: 102rem;
  padding: 0rem 3rem;
  margin: 0 auto;
}

.price-cheker-heading {
  padding: 1.25rem 2.5rem 1.25rem 1.5rem;
  margin: 2rem 0;
  font-size: 1.6rem;
  border-radius: 4px;
}

.overview-chart {
  padding-top: 2rem;
}

.detail-chart {
  padding: 10rem 0rem;
}

@media screen and (max-width: 960px) {
  .price-cheker-heading {
    font-size: 1.2rem;
  }
}
</style>

<style lang="scss">
body {
  min-width: 0rem !important;
}
</style>
